import { NavigationService } from '@ebw-monorepo/navigation';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebw-navigation-button',
  templateUrl: './navigation-button.component.html',
  styleUrls: ['./navigation-button.component.scss']
})
export class NavigationButtonComponent implements OnInit {

  constructor(private navigation: NavigationService) { }

  ngOnInit(): void {
  }

  back() {
    this.navigation.goBack();
  }
}
